module.exports = __webpack_public_path__ + "static/media/back1.d9aa2df2.jpg";